module.exports = __webpack_public_path__ + "img/logo-dark.049ca67f.svg";